// extracted by mini-css-extract-plugin
export var alertIcon = "_pd-0";